import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    if (prevPathname.current !== location.pathname) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      prevPathname.current = location.pathname;
    }
  }, [location.pathname]);

  return null;
}